import {
  HttpEvent,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { LoadingService } from '@esp-enrollment-form/shared-ui';
import { catchError, tap, throwError } from 'rxjs';

export const loadingInterceptor: HttpInterceptorFn = (request, next) => {
  const _loadingService = inject(LoadingService);
  let counter = 0;

  if (!request.url.includes('assets')) {
    counter++;
    _loadingService.setLoading(true, request.url);

    return next(request).pipe(
      catchError((err) => {
        _loadingService.setLoading(false, request.url);
        counter--;
        return throwError(() => err);
      }),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          counter--;
        }
        return event;
      }),
      tap(() => {
        if (!counter) {
          _loadingService.setLoading(false, request.url);
        }
      }),
    );
  } else {
    return next(request);
  }
};
